import { useT } from "@/lib/i18n"
import { Link, useNavigate } from "@tanstack/react-router"
import { ChevronRight } from "lucide-react"
import { EnvDot, ScopeForm } from "@/components/shell/scope-switcher"
import { loadRecentScopes } from "@/lib/connection"
import { useSession } from "@/lib/session"
import { EntryFrame } from "./connect"

export function ChooseScopePage() {
  const t = useT()
  const navigate = useNavigate()
  const { connection } = useSession()
  const recent = loadRecentScopes()
  return (
    <EntryFrame title={t("scope.chooseTitle")} description={t("scope.chooseDescription", { cell: connection?.baseUrl ?? t("scope.aCell") })}>
      {recent.length > 0 ? (
        <ul className="mb-6 divide-y divide-border-subtle overflow-hidden rounded-lg border border-border-subtle">
          {recent.map((s) => (
            <li key={`${s.orgId}/${s.environmentId}`}>
              <Link to="/$orgId/$environmentId" params={s} className="group flex items-center gap-2.5 px-3 py-2.5 text-sm transition-colors hover:bg-raised">
                <EnvDot environmentId={s.environmentId} />
                <span className="font-medium">{s.orgId}</span>
                <span className="text-muted-foreground">{s.environmentId}</span>
                <ChevronRight className="rtl-mirror ms-auto size-3.5 text-subtle-foreground group-hover:text-foreground" />
              </Link>
            </li>
          ))}
        </ul>
      ) : null}
      <ScopeForm onSubmit={(scope) => void navigate({ to: "/$orgId/$environmentId", params: scope })} />
      <p className="mt-6 text-xs text-subtle-foreground">
        {t("scope.wrongCell")}{" "}
        <Link to="/connect" className="text-muted-foreground underline hover:text-foreground">
          {t("scope.changeConnection")}
        </Link>
      </p>
    </EntryFrame>
  )
}
